import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// App Modules

import { AppRoutingModule } from './app-routing/app-routing.module';
import { SharedModule } from './shared/shared.module';
import { PanotestModule } from './panotest/panotest.module';

// Firebase

import {HomePageComponent} from './home-page/home-page.component';
import {AppComponent} from './app.component';
import {GoogleAnalyticsService} from './google-analytics.service';



@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,



  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    PanotestModule,
    BrowserAnimationsModule

  ],
  exports: [],

  providers: [GoogleAnalyticsService],
  bootstrap: [AppComponent]
})

export class AppModule { }
